export default "__VITE_ASSET__BbKNQsVI__"